// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Page from "../../resources/layout-and-structure/Page.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as Notifier from "../../bundles/Notifier/Notifier.res.js";
import * as CatalogProduct from "../../modules/Catalog/CatalogProduct.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CatalogProductEditFormPageActions from "../../modules/Catalog/CatalogProductEditFormPageActions.res.js";
import * as CatalogProductEditFormInformationFieldsetPanel from "../../modules/Catalog/CatalogProductEditFormInformationFieldsetPanel.res.js";
import * as CatalogProductEditFormOrganisationFieldsetPanel from "../../modules/Catalog/CatalogProductEditFormOrganisationFieldsetPanel.res.js";

function CatalogProductEditPage(props) {
  let contextData = props.contextData;
  let editionMode = props.editionMode;
  let notifier = Notifier.use(undefined, undefined);
  let renderActions = () => JsxRuntime.jsx(CatalogProductEditFormPageActions.make, {
    editionMode: editionMode
  });
  let formattedTitle;
  let exit = 0;
  if (editionMode && contextData !== undefined) {
    formattedTitle = I18n.t("Editing") + " " + contextData.name;
  } else {
    exit = 1;
  }
  if (exit === 1) {
    let productLabel = CatalogProduct.Kind.toLabel(undefined, false, props.productKind);
    formattedTitle = I18n.template(I18n.t("Step {{step}} | Create {{fulfill}}"), {
      step: "1",
      fulfill: I18n.t("a new " + productLabel)
    }, undefined);
  }
  return JsxRuntime.jsxs(Page.make, {
    children: [
      JsxRuntime.jsx(Notifier.Banner.make, {
        notifier: notifier
      }),
      JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsxs(Stack.make, {
          children: [
            JsxRuntime.jsx(CatalogProductEditFormInformationFieldsetPanel.make, {}),
            editionMode ? null : JsxRuntime.jsx(CatalogProductEditFormOrganisationFieldsetPanel.make, {})
          ],
          space: "xlarge"
        }),
        spaceTop: "large"
      })
    ],
    title: formattedTitle,
    subtitle: props.shopName,
    renderActions: renderActions
  });
}

let make = React.memo(CatalogProductEditPage);

let Config;

export {
  Config,
  make,
}
/* make Not a pure module */
